"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
Entry.Scroller = /*#__PURE__*/function () {
  function Scroller(board, horizontal, vertical) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Scroller);
    (0, _defineProperty2["default"])(this, "onMouseMove", function (e) {
      console.log('onMouseMove');
      e.stopPropagation();
      e.preventDefault();
      if (window.TouchEvent && e instanceof window.TouchEvent) {
        e = e.changedTouches[0];
      }
      var dragInstance = _this.dragInstance;
      if (_this.scrollType === 'horizontal') {
        _this.scroll((-e.pageX + dragInstance.offsetX) / _this.hRatio, 0);
      } else {
        _this.scroll(0, (-e.pageY + dragInstance.offsetY) / _this.vRatio);
      }
      dragInstance.set({
        offsetX: e.pageX,
        offsetY: e.pageY
      });
    });
    (0, _defineProperty2["default"])(this, "onMouseUp", function (e) {
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      console.log('onMouseUp');
      _this.removeEventListener(document, ['mousemove', 'touchmove'], _this.onMouseMove);
      _this.removeEventListener(document, ['mouseup', 'touchend'], _this.onMouseUp);
      delete _this.dragInstance;
      delete _this.scrollType;
    });
    (0, _defineProperty2["default"])(this, "onMouseDown", function (e) {
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      console.log('onMouseDown', e.button, e);
      if (e.button === 0 || e instanceof window.TouchEvent) {
        console.log('go into add event');
        _this.scrollType = e.target.type;
        if (Entry.documentMousedown) {
          Entry.documentMousedown.notify(e);
        }
        _this.addEventListener(document, ['mousemove', 'touchmove'], _this.onMouseMove, {
          passive: false
        });
        _this.addEventListener(document, ['mouseup', 'touchend'], _this.onMouseUp);
        _this.dragInstance = new Entry.DragInstance({
          startX: e.pageX,
          startY: e.pageY,
          offsetX: e.pageX,
          offsetY: e.pageY
        });
      }
      e.stopPropagation();
    });
    this._horizontal = horizontal === undefined ? true : horizontal;
    this._vertical = vertical === undefined ? true : vertical;
    this.board = board;
    this.canRAF = true;
    this.svgGroup = null;
    this.hWidth = 0;
    this.hX = 0;
    this.hRatio = 0;
    this.vWidth = 0;
    this.vY = 0;
    this.vRatio = 0;
    this._visible = true;
    this._opacity = -1;
    this.createScrollBar();
    this.setOpacity(0);
    this._bindEvent();
    this._scrollCommand = (0, _debounce["default"])(Entry["do"], 200);
  }
  return (0, _createClass2["default"])(Scroller, [{
    key: "SCROLL_WIDTH",
    get: function get() {
      return 8;
    }
  }, {
    key: "RADIUS",
    get: function get() {
      return 2.5;
    }
  }, {
    key: "MARGIN",
    get: function get() {
      return 40;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(dom) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var func = arguments.length > 2 ? arguments[2] : undefined;
      var option = arguments.length > 3 ? arguments[3] : undefined;
      event.forEach(function (e) {
        dom.addEventListener(e, func, option);
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(dom) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var func = arguments.length > 2 ? arguments[2] : undefined;
      event.forEach(function (e) {
        dom.removeEventListener(e, func);
      });
    }
  }, {
    key: "createScrollBar",
    value: function createScrollBar() {
      var r = this.RADIUS;
      var _ref = EntryStatic.colorSet || {},
        _ref$common = _ref.common,
        common = _ref$common === void 0 ? {} : _ref$common;
      this.svgGroup = this.board.svg.elem('g').attr({
        "class": 'boardScrollbar'
      });
      if (this._horizontal) {
        this.hScrollbar = this.svgGroup.elem('rect', {
          height: this.SCROLL_WIDTH,
          rx: r,
          ry: r,
          fill: common.SCROLL_BAR || '#aac5d5',
          "class": 'scrollbar horizontal'
        });
        this.hScrollbar.type = 'horizontal';
        this.addEventListener(this.hScrollbar, ['touchstart', 'mousedown'], this.onMouseDown);
      }
      if (this._vertical) {
        this.vScrollbar = this.svgGroup.elem('rect', {
          width: this.SCROLL_WIDTH,
          rx: r,
          ry: r,
          fill: common.SCROLL_BAR || '#aac5d5',
          "class": 'scrollbar vertical'
        });
        this.vScrollbar.type = 'vertical';
        this.addEventListener(this.vScrollbar, ['touchstart', 'mousedown'], this.onMouseDown);
      }
    }
  }, {
    key: "updateScrollBar",
    value: function updateScrollBar(dx, dy) {
      if (this._horizontal) {
        this.hX -= dx * this.hRatio;
        this.hScrollbar.attr({
          x: this.hX || 0
        });
      }
      if (this._vertical) {
        this.vY -= dy * this.vRatio;
        this.vScrollbar.attr({
          y: this.vY
        });
      }
    }
  }, {
    key: "scroll",
    value: function scroll(x, y, skipCommand) {
      if (!this.board.code) {
        return;
      }
      var board = this.board;
      var svgRect = board.getSvgDomRect();
      var clientRect = board.svgBlockGroup.getBoundingClientRect();
      var bBox = {
        x: clientRect.left - this.board.offset().left,
        y: clientRect.top - this.board.offset().top,
        width: clientRect.width,
        height: clientRect.height
      };
      var sWidth = svgRect.width;
      var sHeight = svgRect.height;
      if (bBox.width && bBox.height) {
        if (sWidth / 2 > bBox.width) {
          x = Math.max(-bBox.x + 1, x);
          x = Math.min(sWidth - bBox.width - bBox.x - 1, x);
        } else {
          x = Math.max(sWidth / 2 - bBox.x - bBox.width, x);
          x = Math.min(sWidth / 2 - bBox.x, x);
        }
        if (sHeight / 2 > bBox.height) {
          y = Math.max(-bBox.y + 1, y);
          y = Math.min(sHeight - bBox.height - bBox.y - 1, y);
        } else {
          y = Math.max(sHeight / 2 - bBox.y - bBox.height, y);
          y = Math.min(sHeight / 2 - bBox.y, y);
        }
      }
      this._scroll(x, y);
      if (skipCommand !== true) {
        if (!this._diffs) {
          this._diffs = [0, 0];
        }
        this._diffs[0] += x;
        this._diffs[1] += y;
        this._scrollCommand('scrollBoard', this._diffs[0], this._diffs[1], true);
      }
      this.canRAF = true;
    }
  }, {
    key: "_scroll",
    value: function _scroll(x, y) {
      this.board.code.moveBy(x, y);
      this.updateScrollBar(x, y);
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      if (visible == this.isVisible()) {
        return;
      }
      this._visible = visible;
      this.svgGroup.attr({
        display: visible === true ? 'block' : 'none'
      });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this._visible;
    }
  }, {
    key: "setOpacity",
    value: function setOpacity(value) {
      if (this._opacity == value) {
        return;
      }
      this.hScrollbar.attr({
        opacity: value
      });
      this.vScrollbar.attr({
        opacity: value
      });
      this._opacity = value;
    }
  }, {
    key: "resizeScrollBar",
    value: function resizeScrollBar() {
      if (!this._visible) {
        return;
      }
      var board = this.board;
      var offset = board.offset();
      var svgRect = board.getSvgDomRect();
      var bRect = board.svgBlockGroup.getBoundingClientRect();
      var width = svgRect.width;
      var height = svgRect.height;
      var bBox = {
        x: bRect.left - offset.left,
        y: bRect.top - offset.top,
        width: bRect.width,
        height: bRect.height
      };

      // hScroll
      if (this._horizontal) {
        var sWidth = svgRect.width;
        var marginSWitdh = svgRect.width - this.MARGIN;
        var limit = sWidth;
        var ratio = 0.6;
        var hWidth = 0;
        if (sWidth / 2 > bBox.width) {
          limit = sWidth - bBox.width;
          ratio = Math.min(limit / marginSWitdh, ratio);
          hWidth = marginSWitdh * ratio;
          this.hRatio = (marginSWitdh - hWidth) / limit;
          this.hX = marginSWitdh + this.MARGIN / 2 - hWidth - bBox.x * this.hRatio;
        } else {
          limit = bBox.width;
          ratio = Math.min(marginSWitdh / limit, ratio);
          hWidth = marginSWitdh * ratio;
          this.hRatio = (marginSWitdh - hWidth) / limit;
          this.hX = (sWidth / 2 - bBox.x) * this.hRatio + this.MARGIN / 2;
        }
        this.hScrollbar.attr({
          width: hWidth,
          x: this.hX,
          y: height - 2 * this.SCROLL_WIDTH
        });
      }

      // vScroll
      if (this._vertical) {
        var sHeight = svgRect.height;
        var marginSHeight = svgRect.height - this.MARGIN;
        var _limit = height;
        var _ratio = 0.6;
        var vHeight = 0;
        if (sHeight / 2 > bBox.height) {
          _limit = sHeight - bBox.height;
          _ratio = Math.min(_limit / marginSHeight, _ratio);
          vHeight = marginSHeight * _ratio;
          this.vRatio = (marginSHeight - vHeight) / _limit;
          this.vY = marginSHeight + this.MARGIN / 2 - vHeight - bBox.y * this.vRatio;
        } else {
          _limit = bBox.height;
          _ratio = Math.min(marginSHeight / _limit, _ratio);
          vHeight = marginSHeight * _ratio;
          this.vRatio = (marginSHeight - vHeight) / _limit;
          this.vY = (sHeight / 2 - bBox.y) * this.vRatio + this.MARGIN / 2;
        }
        this.vScrollbar.attr({
          height: vHeight,
          y: this.vY,
          x: width - 2 * this.SCROLL_WIDTH
        });
      }
    }
  }, {
    key: "_bindEvent",
    value: function _bindEvent() {
      var dResizeScrollBar = (0, _debounce["default"])(this.resizeScrollBar, 250);
      this.board.changeEvent.attach(this, dResizeScrollBar);
      if (Entry.windowResized) {
        Entry.windowResized.attach(this, dResizeScrollBar);
      }
    }
  }]);
}();